import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBriefcaseOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		d: "M5.001 4.33H3.668a2 2 0 0 0-2 2v5.334a2 2 0 0 0 2 2h8.667a2 2 0 0 0 2-2V6.331a2 2 0 0 0-2-2H11m-6 0v-.667a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v.667m-6 0h6"
	})
});
export default SvgBriefcaseOutlined;
